import React from "react";
import LegalPage from "./LegalPage";

export default function TermsPage() {
    return (
        <LegalPage title="Terms of Service">
            <div className="space-y-5 text-lg leading-relaxed">
                <p>
                    Welcome to ClearCursor. By using this website you agree to the
                    following terms. If you don't agree, please don't use the site.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    1. What ClearCursor is
                </h2>
                <p>
                    ClearCursor is a free accessibility tool that overlays a
                    high-visibility mouse pointer on this website and provides
                    step-by-step guides for changing your operating system's real
                    pointer. It is a courtesy tool, not medical or assistive
                    technology certified for any specific condition.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    2. Ownership & copyright
                </h2>
                <p>
                    All code, text, design, logos, and other content on this site
                    are © 2026 Christopher T. Parker. All rights reserved. You may
                    view the site in a normal browser session, but you may not:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>Copy, scrape, or mirror any part of the site.</li>
                    <li>Reverse-engineer or repackage the source code.</li>
                    <li>Use the name "ClearCursor" or the ClearCursor design in a competing product.</li>
                    <li>Resell, sublicense, or redistribute any part of the site.</li>
                </ul>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    3. Voluntary tips
                </h2>
                <p>
                    Tips paid through the "Support this project" button are
                    voluntary donations processed by Stripe. Tips are non-refundable
                    except where required by law. Contact
                    {" "}<a href="mailto:chrisparker@gmail.com" className="underline">
                        chrisparker@gmail.com
                    </a>{" "}
                    within 14 days if you believe a payment was made in error.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    4. No warranty
                </h2>
                <p>
                    ClearCursor is provided "as is" without warranties of any kind.
                    We do our best to keep the site working, but we don't guarantee
                    uptime, compatibility with every browser or device, or that the
                    tool will meet your specific accessibility needs.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    5. Limitation of liability
                </h2>
                <p>
                    To the maximum extent allowed by law, Christopher T. Parker and
                    ClearCursor will not be liable for any indirect, incidental, or
                    consequential damages arising from your use of the site. Total
                    liability, if any, is limited to the amount you tipped in the
                    last 12 months (which for most users is $0).
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    6. Changes
                </h2>
                <p>
                    We may update these terms from time to time. The "last updated"
                    date at the top will change when we do. Continued use of the
                    site after an update means you accept the new terms.
                </p>

                <h2 className="font-display font-bold text-2xl text-slate-900 mt-6">
                    7. Contact
                </h2>
                <p>
                    Questions? Email
                    {" "}<a href="mailto:chrisparker@gmail.com" className="underline">
                        chrisparker@gmail.com
                    </a>.
                </p>
            </div>
        </LegalPage>
    );
}
